/**
 * Shuffles cart collection recommendations and shows a random subset.
 */
window.shuffleCartCollectionRecommendations = (containerEl) => {
  const container = containerEl || document.getElementById('cart-recommendations');
  if (!container) return;

  const root = container.classList.contains('cart-recommendations')
    ? container
    : container.querySelector('.cart-recommendations');
  if (!root) return;

  const list = root.querySelector('ul[role="list"]');
  if (!list) return;

  const limit = parseInt(root.dataset.limit, 10) || 3;
  const items = [...list.querySelectorAll(':scope > li')];
  if (items.length === 0) return;

  for (let i = items.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [items[i], items[j]] = [items[j], items[i]];
  }

  const visibleItems = items.slice(0, limit);
  list.replaceChildren(...visibleItems);
};

if (!customElements.get('cart-collection-recommendations')) {
  class CartCollectionRecommendations extends HTMLElement {
    connectedCallback() {
      window.shuffleCartCollectionRecommendations(this);
    }
  }

  customElements.define('cart-collection-recommendations', CartCollectionRecommendations);
}
